// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.BrazeBanner-module_brazeBanner__T3rQc {
    width: 100%;
}`, "",{"version":3,"sources":["webpack://./../../packages/consumer/src/widgets/Stories/BrazeBanner.module.css"],"names":[],"mappings":"AAAA;IACI,WAAW;AACf","sourcesContent":[".brazeBanner {\n    width: 100%;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"brazeBanner": `BrazeBanner-module_brazeBanner__T3rQc`
};
export default ___CSS_LOADER_EXPORT___;
